import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

/*
#B96AA1 --> Violetto
#9052AC --> Vialo scuro
#2BD49E --> Teal
#F7E7F3 --> Rosa
#1FA376 --> Verde scuro

#21505F --> Blu
#133641 --> Blue scure

#E9F3FF --> Celeste
#BFDFDF --> Bluetto
*/

// const theme = {
//   themes: {
//     light: {
//       primary: '#9052AC', //colors.pink.darken4,
//       secondary: colors.grey.darken1,
//       accent: colors.shades.black,
//       error: colors.red.accent3
//     },
//     dark: {
//       primary: colors.blue.lighten3
//     }
//   }
// }

export default new Vuetify({})
